export const CHAT_PATH = '/chat';
export const CONVERSATION_PATH = '/chat/:conversationId';
export const PROMPT_LIBRARY_PATH = '/chat/prompts';
// shared projects (ENG-11385) open as a page in place of the thread; the conversation sidebar stays
export const PROJECTS_PATH = '/chat/projects';
// the optional section keeps the open settings card in the URL, like the agent config's tab
export const PROJECT_PATH = '/chat/projects/:projectId/:section?';
export const AUTOMATIONS_PATH = '/chat/automations';
export const AUTOMATION_PATH = '/chat/automations/:scheduleId';

export const SCHEDULE_RUNS_UPDATE_INTERVAL = 60000;
export const SCHEDULE_TEST_RUN_POLL_INTERVAL = 3000;
export const SCHEDULE_TEST_RUN_MAX_WAIT = 10 * 60 * 1000;

export const CHAT_ENTRY_POINT = {
    SIDEBAR: 'SIDEBAR',
    MARKETING_BANNER: 'MARKETING_BANNER',
    LOGIN_REDIRECT: 'LOGIN_REDIRECT',
    DIRECT_URL: 'DIRECT_URL',
} as const;

export const WORKI_REQUEST_CALL_URL = 'https://meetings-eu1.hubspot.com/natascha-flammann/worki-chat-agent';
export const CHANNEL_FIELDS = [
    'rfqProcessingChannels',
    'orderProcessingChannels',
    'orderConfirmationProcessingChannels',
    'invoiceProcessingChannels',
    'propertyBillProcessingChannels',
    'deliveryNoteProcessingChannels',
    'listOfServicesProcessingChannels',
    'universalProcessingChannels',
];

// snapshots shared with the viewer change through other people's actions, so the sidebar list polls
export const SHARED_CONVERSATIONS_UPDATE_INTERVAL = 60000;
